import { i18n } from '@lingui/core'
import { Paper } from '@mui/material'
import * as React from 'react'
import NewsletterForm from './NewsletterForm'

type NewsLetterSectionProps = {
  isFromBlog?: boolean
}
const NewsletterSection: React.FC<NewsLetterSectionProps> = (props: NewsLetterSectionProps) => {
  const { isFromBlog = true } = props
  const [isSubscriptionSuccessful, setIsSubscriptionSuccessful] = React.useState<boolean>(false)
  return (
    <section className='flex w-full flex-col items-center justify-center bg-none px-9 py-4 leading-9 max-md:px-5'>
      <Paper
        elevation={3}
        sx={{
          backgroundColor: 'white',
          borderTop: '12px inset solid #680BC5',
          borderStyle: 'solid',
          borderRadius: 0,
          padding: '12px',
        }}
        className='bg-white flex w-auto max-w-[732px] flex-col border border-t-[12px] border-solid border-black border-t-new-templi-purple pb-5 shadow-sm max-md:max-w-full md:w-[732px]'
      >
        {isSubscriptionSuccessful ? (
          <span className='Type-XXXL-Medium my-10 flex w-[417px] self-center'>
            {i18n._('Thanks! Please check your email to confirm your subscription.')}
          </span>
        ) : (
          <div className='mt-5 flex w-[417px] max-w-full flex-col self-center'>
            <h2 className='Type-XXXL-Medium self-start text-[34px] leading-none text-opacity-90'>
              {i18n._('Join our newsletter')}
            </h2>
            <p className='text-neutral-900 Type-XL-Regular mt-2 text-opacity-90'>
              {i18n._('Get access to our best deals, tips, and inspiration')}
            </p>
            <NewsletterForm
              emailPlaceholder='janedoe@gmail.com'
              buttonText={i18n._('JOIN')}
              setIsSubscriptionSuccessful={setIsSubscriptionSuccessful}
              isFromBlog={isFromBlog}
            />
            <p className='text-neutral-900 Type-Large-Medium mt-3 self-start text-[10px] text-opacity-90'>
              {i18n._('No spam, we hate it more than you do.')}
            </p>
          </div>
        )}
      </Paper>
    </section>
  )
}

// eslint-disable-next-line import/no-default-export
export default NewsletterSection
